import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getEntries, getSearch, getFilters, getSettings } from '../../common/services/selectors';
import NSIRCCareersItem from './NSIRCCareersItem';
import NSIRCCareersSidebarFilter from './NSIRCCareersSidebarFilter';
import Pager from '../../common/components/_Pager';

function NSIRCCareers({ entries, search, filters, settings }) { 
    const { items = [] } = entries || {};
	return (
        <div className="row nsirc">
            <div className="column large-10">
                <div className="careers-listing">
                    <div className="row">
                        <div className="column large-8">
                            <p className="careers-listing__title course">Course Title</p>
                        </div>
                        <div className="column large-2">
                            <p className="careers-listing__title location">Location</p>
                        </div>
                        {/* <div className="column large-2">
                            <p className="careers-listing__title contract">Contract</p>
                        </div> */}
                    </div>
                    <div className="row">
                        <div className="large-12 column">
                            {entries.totalCount === 0 && <p>Nothing Found</p>}
                            {entries.totalCount > 0 && 
                                items.map((entry, index) => <NSIRCCareersItem key={entry.sys.id} entry={entry} index={index} />) }
                        </div>
                    </div>
                    {entries.totalCount > 10 && <Pager entries={entries} search={search} settings={settings} />}
                </div>
            </div>
            {/* <NSIRCCareersSidebarFilter search={search} filters={filters} /> */}
        </div>
	);
}


NSIRCCareers.propTypes = {
    entries: PropTypes.object,
    filters: PropTypes.object,
    search: PropTypes.object,
    settings: PropTypes.object

};

const mapStateToProps = state => ({ entries: getEntries(state), search: getSearch(state), filters: getFilters(state), settings: getSettings(state) });

export default connect(mapStateToProps)(NSIRCCareers);